// **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "insert",
        regionType:  "region_code_currency_code",
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "shop_base",
        hasFlag: "no",
        selectorFlagMap: {'fr': 'fr', 'en': 'en'},
        displayType: "language_code",
        fontColor: "#000000",
        backgroundColor: "#FFFFFF",
        backgroundOpacity: "1.0",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",
        defaultRegion: "CA",
        primaryRegionById: {},
        availableRegionsByCode: {},
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "Canada", "code": "CA", "currency": {"code": "CAD", "symbol": "$"}, "languages": {"English": {"name": "English", "native_name": "English", "code": "en", "default": true}, "Fran\u00e7ais": {"name": "Fran\u00e7ais (French)", "native_name": "Fran\u00e7ais", "code": "fr", "default": false}}, "primary": true}, {"name": "United States", "code": "US", "currency": {"code": "USD", "symbol": "$"}, "languages": {"English": {"name": "English", "native_name": "English", "code": "en", "default": true}}, "primary": false}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
        